<div *ngIf="isAtlasEnabledUser" class="atlas-container">
  <button *ngIf="!isOpen" class="chat-launcher" type="button" (click)="toggleOpen()">
    <span class="chat-launcher-logo" aria-hidden="true"></span>
    <span>Atlas</span>
    <span
      *ngIf="hasElevatedFraudDetectionBadge"
      class="chat-launcher-fraud-badge"
      [ngClass]="'chat-launcher-fraud-badge-' + fraudDetectionBadgeTone"
    >
      {{ fraudDetectionBadgeLabel }}
      <span *ngIf="hasFraudDetectionFlagCount" class="chat-launcher-fraud-flag-count">
        <span class="chat-launcher-fraud-flag-icon" aria-hidden="true"></span>
        {{ fraudDetectionFlagCount }}
      </span>
    </span>
    <span *ngIf="hasUnreadBotResponse" class="chat-launcher-notification" aria-hidden="true"></span>
  </button>

  <div *ngIf="isOpen" class="chat-shell" [class.chat-shell-rail-open]="isActionRailOpen">
    <aside class="chat-action-rail" [class.chat-action-rail-open]="isActionRailOpen" [class.chat-action-rail-closed]="!isActionRailOpen">
      <div class="chat-action-rail-list">
        <button
          class="chat-action-item chat-context-input-trigger"
          type="button"
          data-tooltip="Case Context fields"
          aria-label="Case Context fields"
          [disabled]="areAtlasCaseFeaturesDisabled"
          (click)="openContextInputsDialog()"
        >
          <span class="chat-action-item-icon chat-context-input-trigger-icon" aria-hidden="true"></span>
        </button>
        <button
          class="chat-action-item chat-template-trigger"
          type="button"
          [attr.data-tooltip]="firstContactTemplateTooltip"
          aria-label="First contact"
          [disabled]="isFirstContactTemplateDisabled"
          (click)="openFirstContactTemplateDialog()"
        >
          <span class="chat-action-item-icon chat-template-trigger-icon" aria-hidden="true"></span>
        </button>
        <!--
        <button
          class="chat-action-item voice-to-text-summary-trigger"
          type="button"
          data-tooltip="Voice-to-text summary"
          aria-label="Voice-to-text summary"
          [disabled]="areAtlasCaseFeaturesDisabled"
          (click)="onVoiceToTextSummaryClick()"
        >
          <span class="chat-action-item-icon voice-to-text-summary-trigger-icon" aria-hidden="true"></span>
        </button>
        -->
        <!--
        <button
          class="chat-action-item case-validation-trigger"
          type="button"
          data-tooltip="Case validation"
          aria-label="Case validation"
          [disabled]="areAtlasCaseFeaturesDisabled"
          (click)="onCaseValidationClick()"
        >
          <span class="chat-action-item-icon case-validation-trigger-icon" aria-hidden="true"></span>
        </button>
        -->
        <!--
        <button
          class="chat-action-item chat-translate-trigger"
          type="button"
          data-tooltip="Translation"
          aria-label="Translation"
          [disabled]="!hasSelectedCase"
          (click)="onDocumentTranslationClick()"
        >
          <span class="chat-action-item-icon chat-translate-trigger-icon" aria-hidden="true"></span>
        </button>
        <button
          class="chat-action-item chat-anonymize-trigger"
          type="button"
          data-tooltip="Document anonymization"
          aria-label="Document anonymization"
          [disabled]="!hasSelectedCase"
          (click)="onDocumentAnonymizationClick()"
        >
          <span class="chat-action-item-icon chat-anonymize-trigger-icon" aria-hidden="true"></span>
        </button>
        -->
        <button
          class="chat-action-item fraud-detection-trigger"
          type="button"
          data-tooltip="Fraud detection"
          aria-label="Fraud detection"
          [disabled]="areAtlasCaseFeaturesDisabled"
          (click)="onFraudDetectionClick()"
        >
          <span
            *ngIf="hasFraudDetectionBadge"
            class="fraud-detection-score-badge"
            [ngClass]="'fraud-detection-score-badge-' + (isFraudDetectionReviewed ? 'green' : fraudDetectionBadgeTone)"
            [class.fraud-detection-score-badge-flag]="hasFraudDetectionFlagCount"
            [class.fraud-detection-score-badge-reviewed]="isFraudDetectionReviewed"
            [attr.title]="isFraudDetectionReviewed ? 'Fraud review completed' : (hasFraudDetectionFlagCount ? 'Fraud flags detected: ' + fraudDetectionFlagCount : 'Fraud score: ' + fraudDetectionBadgeText)"
          >
            <span *ngIf="isFraudDetectionReviewed; else fraudDetectionNotReviewedBadge" class="fraud-detection-score-badge-check-icon" aria-hidden="true"></span>
            <ng-template #fraudDetectionNotReviewedBadge>
              <span *ngIf="hasFraudDetectionFlagCount; else fraudDetectionScoreBadgeText" class="fraud-detection-score-badge-flag-icon" aria-hidden="true"></span>
            </ng-template>
            <ng-template #fraudDetectionScoreBadgeText>{{ fraudDetectionBadgeText }}</ng-template>
          </span>
          <span class="chat-action-item-icon fraud-detection-trigger-icon" aria-hidden="true"></span>
        </button>
        <button
          class="chat-action-item chat-new"
          type="button"
          [attr.data-tooltip]="hasAtlasChatSessionCreationLimitReached ? atlasChatSessionCreationLimitText : (isCreatingNewChat ? 'Creating new chat...' : 'New chat')"
          [attr.aria-label]="isCreatingNewChat ? 'Creating new chat' : 'New chat'"
          [attr.aria-busy]="isCreatingNewChat"
          (click)="clearChat()"
          [disabled]="!isAtlasBackendAvailable || isCreatingNewChat || !canStartNewAtlasChat"
        >
          <img class="chat-action-item-icon chat-new-icon" src="/assets/icons/atlas/new-chat-icon.png" width="26" height="26" alt="" aria-hidden="true" />
        </button>
        <button
          class="chat-action-item chat-history-trigger"
          type="button"
          data-tooltip="Chat history"
          aria-label="Chat history"
          [disabled]="!isAtlasBackendAvailable"
          (click)="openChatHistoryDialog()"
        >
          <span class="chat-action-item-icon chat-history-trigger-icon" aria-hidden="true"></span>
        </button>
      </div>
    </aside>

    <div class="chat-popup">
      <div class="chat-header">
        <div class="chat-title-group">
          <button
            class="chat-logo"
            type="button"
            title="About Atlas"
            aria-label="About Atlas"
            (click)="openInfoDialog()"
          ></button>
          <div class="chat-heading">
            <div class="chat-title">Atlas</div>
          </div>
        </div>
        <button class="chat-close" type="button" aria-label="Close Atlas" (click)="toggleOpen()">x</button>
      </div>

      <div class="chat-context-bar">
        <button
          class="chat-actions-toggle"
          type="button"
          data-tooltip="Toggle Atlas menu"
          aria-label="Toggle Atlas menu"
          [attr.aria-expanded]="isActionRailOpen"
          [class.chat-actions-toggle-open]="isActionRailOpen"
          [class.chat-actions-toggle-closed]="!isActionRailOpen"
          (click)="toggleActionRail()"
        >
          <span class="chat-actions-toggle-icon" aria-hidden="true"></span>
        </button>

        <div class="chat-context">
          <div class="chat-context-text">
            <div class="chat-context-label">Case context chat mode</div>
            <div class="chat-context-value">{{ activeChatCaseLabel }}</div>
          </div>
          <button
            class="chat-context-state"
            type="button"
            role="switch"
            [disabled]="isCaseContextToggleDisabled"
            [attr.aria-checked]="isCaseContextModeOn"
            [class.chat-context-state-on]="isCaseContextModeOn"
            [class.chat-context-state-off]="!isCaseContextModeOn"
            (click)="toggleCaseContext()"
          >
            <span class="chat-context-state-dot" aria-hidden="true"></span>
            <span class="chat-context-state-text">{{ isCaseContextModeOn ? 'On' : 'Off' }}</span>
          </button>
        </div>
      </div>

      <div
        #chatBody
        class="chat-body"
        (click)="onChatBodyClick($event)"
        (wheel)="cancelScheduledScrollToBottom()"
        (touchstart)="cancelScheduledScrollToBottom()"
      >
      <div *ngIf="!isAtlasBackendAvailable" class="atlas-unavailable-state" aria-live="polite">
        <span class="atlas-unavailable-icon" aria-hidden="true">!</span>
        <div>
          <div class="atlas-unavailable-title">Atlas is currently unavailable</div>
          <div class="atlas-unavailable-text">The Atlas backend service cannot be reached right now. Please try again later.</div>
        </div>
      </div>
      <ng-container *ngIf="isAtlasBackendAvailable">
      <div *ngIf="hasBlockedChatSessionCreationLimit" class="atlas-unavailable-state" aria-live="polite">
        <span class="atlas-unavailable-icon" aria-hidden="true">!</span>
        <div>
          <div class="atlas-unavailable-title">{{ chatSessionCreationLimitTitle }}</div>
          <div class="atlas-unavailable-text">{{ chatSessionCreationLimitText }}</div>
        </div>
      </div>
      <div
        *ngFor="let message of messages; let i = index"
        class="message-row"
        [class.message-row-user]="message.author === 'user'"
        [class.message-row-system]="message.author === 'system'"
      >
        <div class="message-block">
          <div *ngIf="formatMessageTimestamp(message.timestamp)" class="message-timestamp">
            {{ formatMessageTimestamp(message.timestamp) }}
          </div>
          <div *ngIf="message.author === 'system'; else chatMessageBubble" class="message-error-notice">
            <span class="message-error-icon" aria-hidden="true">!</span>
            <span>{{ message.text }}</span>
          </div>
          <ng-template #chatMessageBubble>
            <div
              class="message-bubble"
              [class.message-bubble-user]="message.author === 'user'"
            >
              <ng-container *ngIf="message.author === 'bot'; else plainTextMessage">
                <div
                  [innerHTML]="(message.html || message.text)
                    | htmlAttributeModifier: 'a': 'target': '_blank'
                    | htmlAttributeModifier: 'a': 'rel': 'noopener noreferrer'
                    | safeHtml"
                ></div>
              </ng-container>
              <ng-template #plainTextMessage>{{ message.text }}</ng-template>
            </div>
          </ng-template>
          <div *ngIf="message.author === 'user'" class="message-context-indicator">
            <span
              class="message-context-badge"
              [class.message-context-badge-on]="message.caseContextModeEnabled"
              [class.message-context-badge-off]="!message.caseContextModeEnabled"
              [attr.title]="getMessageContextTooltip(message)"
            >
              <ng-container *ngIf="message.caseContextModeEnabled; else contextOffText">
                Case context On
              </ng-container>
              <ng-template #contextOffText>Case context Off</ng-template>
            </span>
          </div>
          <div *ngIf="message.author === 'bot' && message.feedbackEnabled !== false" class="message-reactions message-reactions-attached">
            <button
              class="message-reaction-button message-reaction-button-like"
              [class.message-reaction-button-active]="message.reaction === 'like'"
              type="button"
              aria-label="Like response"
              (click)="setMessageReaction(i, 'like')"
            >
              <span class="message-reaction-icon message-reaction-like" aria-hidden="true"></span>
            </button>
            <button
              class="message-reaction-button message-reaction-button-dislike"
              [class.message-reaction-button-active]="message.reaction === 'dislike'"
              type="button"
              aria-label="Dislike response"
              (click)="setMessageReaction(i, 'dislike')"
            >
              <span class="message-reaction-icon message-reaction-dislike" aria-hidden="true"></span>
            </button>
            <button
              *ngIf="activeCommentIndex !== i"
              class="message-comment-toggle"
              [class.message-comment-toggle-has-value]="!!message.reactionComment"
              type="button"
              [attr.title]="message.reactionComment ? message.reactionComment : 'Add comment'"
              (click)="startEditMessageComment(i)"
            >
              <span class="message-comment-toggle-icon" aria-hidden="true"></span>
              <span class="message-comment-toggle-text">
                {{ message.reactionComment ? message.reactionComment : 'Add comment' }}
              </span>
            </button>
          </div>
          <div *ngIf="message.author === 'bot' && message.feedbackEnabled !== false && activeCommentIndex === i" class="message-comment-wrap">
            <span class="message-comment-input-icon" aria-hidden="true"></span>
            <input
              class="message-comment-input"
              type="text"
              [ngModel]="activeCommentDraft"
              (ngModelChange)="updateActiveCommentDraft($event)"
              (keydown.enter)="onCommentInputEnter($event, i)"
              placeholder="Optional comment..."
            />
          </div>
        </div>
      </div>
      <div *ngIf="isCreatingNewChat" class="creating-chat-state" aria-live="polite">
        <span class="creating-chat-spinner" aria-hidden="true"></span>
        <span>Creating chat...</span>
      </div>
      <div *ngIf="isThinkingVisible" class="message-row">
        <div class="message-bubble thinking-bubble">
          <span class="thinking-dot"></span>
          <span class="thinking-dot"></span>
          <span class="thinking-dot"></span>
        </div>
      </div>
      </ng-container>
      </div>

      <div class="chat-suggestions">
        <div class="chat-suggestions-header">
          <div class="chat-suggestions-title">
            <div class="chat-suggestions-label">Suggested prompts</div>
          </div>
          <button
            class="chat-suggestions-toggle"
            type="button"
            [disabled]="hasBlockedChatSessionCreationLimit
              || !canSendMoreAtlasMessages
              || hasActiveChatSessionMessageLimitReached"
            (click)="openAdditionalPromptsDialog()"
          >
            Show
          </button>
        </div>
      </div>

      <div class="chat-input-row">
        <input
          #chatInput
          class="chat-input"
          type="text"
          [(ngModel)]="draftMessage"
          [attr.maxlength]="maxDraftMessageLength"
          placeholder="Type a message..."
          (keydown.enter)="sendMessage()"
          [disabled]="!isAtlasBackendAvailable
            || hasActivePendingChatResponse
            || isCreatingNewChat
            || !canSendMoreAtlasMessages
            || hasBlockedChatSessionCreationLimit
            || hasBlockedMismatchedCaseContext
            || hasActiveChatSessionMessageLimitReached"
        />
        <button class="chat-send" type="button" aria-label="Send message" data-tooltip="Send message" (click)="sendMessage()" [disabled]="!canSendDraftMessage">
          <img class="chat-send-icon" src="/assets/icons/atlas/send-message-icon.png" width="26" height="26" alt="" aria-hidden="true" />
        </button>
      </div>
      <div
        class="chat-input-count"
        [class.chat-input-count-over-limit]="isDraftMessageTooLong"
        aria-live="polite"
      >
        {{ draftMessageLength }} / {{ maxDraftMessageLength }} characters
      </div>

      <div *ngIf="hasActiveChatSessionMessageLimitReached" class="chat-input-warning">
        <span class="chat-input-warning-icon" aria-hidden="true">!</span>
        <span>{{ atlasChatSessionMessageLimitText }}</span>
      </div>

      <div *ngIf="hasAtlasChatMessageLimitReached" class="chat-input-warning">
        <span class="chat-input-warning-icon" aria-hidden="true">!</span>
        <span>{{ atlasChatMessageLimitText }}</span>
      </div>

      <div *ngIf="hasBlockedChatSessionCreationLimit" class="chat-input-warning">
        <span class="chat-input-warning-icon" aria-hidden="true">!</span>
        <span>{{ chatSessionCreationLimitText }}</span>
      </div>

      <div *ngIf="hasBlockedMismatchedCaseContext" class="chat-input-warning">
        <span class="chat-input-warning-icon" aria-hidden="true">!</span>
        <span>{{ mismatchedCaseContextText }}</span>
      </div>

      <div *ngIf="isDraftMessageTooLong" class="chat-input-warning">
        <span class="chat-input-warning-icon" aria-hidden="true">!</span>
        <span>Messages cannot exceed {{ maxDraftMessageLength }} characters.</span>
      </div>

      <div *ngIf="hasBlockedNationalIdInput" class="chat-input-warning">
        <span class="chat-input-warning-icon" aria-hidden="true">!</span>
        <span>The message has been flagged for containing potential sensitive information and cannot be sent.</span>
      </div>
    </div>
  </div>
</div>
